import React from 'react';

/**
 * Ícone do app SmartForm.
 *
 * O desenho é EMBUTIDO aqui, e não importado de `src/assets/SmartForms.svg`.
 * Dois motivos: o projeto não tem svgr, então um SVG importado viraria URL para
 * `<img>` — e o arquivo não declara `fill` nenhum, o que deixaria o ícone preto
 * fixo, invisível sobre o gradiente do card da loja. Inline, ele herda
 * `currentColor` e o tamanho da fonte, como os ícones do MUI.
 *
 * TROCAR O ARQUIVO .SVG NÃO TEM EFEITO: é preciso regerar este componente a
 * partir dele (remover `id` e `style`, que colidem ou são inválidos em JSX).
 */
export default function SmartFormIcon(props) {
  return (
    <svg
      viewBox="0 0 512 512"
      width="1em"
      height="1em"
      fill="currentColor"
      focusable="false"
      aria-hidden="true"
      {...props}
    >
      <g>
        <path d="M97.882,240.941C43.824,240.941,0,197.118,0,143.059s43.824-97.882,97.882-97.882S195.765,89,195.765,143.059 S151.941,240.941,97.882,240.941z M97.882,210.824c37.426,0,67.765-30.339,67.765-67.765s-30.339-67.765-67.765-67.765 s-67.765,30.339-67.765,67.765S60.457,210.824,97.882,210.824z M496.941,173.176c8.317,0,15.059,6.742,15.059,15.059 c0,8.317-6.742,15.059-15.059,15.059H301.176c-33.267,0-60.235-26.968-60.235-60.235s26.968-60.235,60.235-60.235h195.765 c8.317,0,15.059,6.742,15.059,15.059s-6.742,15.059-15.059,15.059H301.176c-16.634,0-30.118,13.484-30.118,30.118 s13.484,30.118,30.118,30.118H496.941z M496.941,399.059c8.317,0,15.059,6.742,15.059,15.059s-6.742,15.059-15.059,15.059H301.176 c-33.267,0-60.235-26.968-60.235-60.235s26.968-60.235,60.235-60.235h195.765c8.317,0,15.059,6.742,15.059,15.059 s-6.742,15.059-15.059,15.059H301.176c-16.634,0-30.118,13.484-30.118,30.118c0,16.633,13.484,30.118,30.118,30.118H496.941z M97.882,466.824C43.824,466.824,0,423,0,368.941s43.824-97.882,97.882-97.882s97.882,43.823,97.882,97.882 S151.941,466.824,97.882,466.824z M97.882,436.706c37.426,0,67.765-30.339,67.765-67.765s-30.339-67.765-67.765-67.765 s-67.765,30.339-67.765,67.765S60.457,436.706,97.882,436.706z M97.882,406.588c-20.792,0-37.647-16.855-37.647-37.647 c0-20.792,16.855-37.647,37.647-37.647s37.647,16.855,37.647,37.647C135.529,389.733,118.674,406.588,97.882,406.588z" />
      </g>
    </svg>
  );
}
